import T from './SPRINTA/translate/T'
window.languagelog = []
let language = null

window.languagelog.push(`Default: ${language}`)

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
        window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=")
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
        })
    return result
}

language = findGetParameter('lang')

window.languagelog.push(`Parameter: ${language}`)


T.handleUpdate(language => {
    localStorage.setItem('language', language)
    window.languagelog.push(`Updated: ${language}`)
})

if(!language) {
    language = localStorage.getItem('language')
    window.languagelog.push(`LocalStorage: ${language}`)

    if(language !== 'en-US' && language !== 'pt-BR'  && language !== 'es') {
        localStorage.removeItem('language')
        language = ''
        window.languagelog.push(`Removed localstorage: ${language}`)
    }
}

if(!language) {
    language = navigator.browserLanguage || navigator.language
    window.languagelog.push(`Navigator: ${language}`)
}

T.setLanguages({
    'default': 'pt-BR',
    'en-US': () => import('./languages/en-us.json'),
    'pt-BR': () => import('./languages/pt-br.json'),
    'es': () => import('./languages/es.json'),
})
window.languagelog.push(`To set: ${language}`)
language = T.setLanguage(language)
window.languagelog.push(`Setted: ${language}`)




// WEBPACK FOOTER //
// ./src/translate.config.js